<template>
  <div>
    <ToolbarAuth />
    <Navigation />

    <div class="mt-15 ml-15 mr-15">
      <v-card>
        <v-card-title class="primary--text text-uppercase">
          {{ $t("crud.change") }}
          <v-spacer></v-spacer>
        </v-card-title>
        <v-card-text>
          <FlashMessage :error="error" v-if="error" key="error" />
          <v-text-field
            v-model="dataext.chart_full"
            outlined
            shaped
            label="Chart full"
          />
          <v-text-field
            v-model="dataext.chart_full_en"
            outlined
            shaped
            label="Chart full en"
          />
          <v-text-field
            v-model="dataext.chart_light"
            outlined
            shaped
            label="Chart light"
          />
          <v-text-field v-model="dataext.pqs_a" outlined shaped label="NP-BV" />
          <v-text-field v-model="dataext.pqs_b" outlined shaped label="NP-PH" />
          <v-text-field v-model="dataext.pqs_c" outlined shaped label="PQS-C" />
          <v-text-field v-model="dataext.pqs_d" outlined shaped label="PQS-D" />
          <v-text-field v-model="dataext.pqs_e" outlined shaped label="PQS-E" />
          <v-text-field v-model="dataext.pqs_f" outlined shaped label="PQS-F" />
          <v-text-field v-model="dataext.pqs_g" outlined shaped label="PQS-G" />
          <v-text-field v-model="dataext.pqs_h" outlined shaped label="PQS-H" />
          <v-text-field v-model="dataext.pqs_i" outlined shaped label="PQS-I" />
          <v-text-field v-model="dataext.pqs_j" outlined shaped label="PQS-J" />
          <v-text-field v-model="dataext.plp_a" outlined shaped label="PLP-A" />
          <v-text-field v-model="dataext.plp_b" outlined shaped label="PLP-B" />
          <v-text-field v-model="dataext.plp_c" outlined shaped label="PLP-C" />
          <v-text-field v-model="dataext.plp_d" outlined shaped label="PLP-D" />
          <v-text-field v-model="dataext.plp_e" outlined shaped label="PLP-E" />
          <v-text-field v-model="dataext.plp_f" outlined shaped label="PLP-F" />
          <v-text-field v-model="dataext.plp_g" outlined shaped label="PLP-G" />
          <v-text-field v-model="dataext.plp_h" outlined shaped label="PLP-H" />
          <v-text-field v-model="dataext.plp_i" outlined shaped label="PLP-I" />
          <v-text-field v-model="dataext.plp_j" outlined shaped label="PLP-J" />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <div class="text-end mr-15">
            <v-btn color="accent" @click="closeItem()" class="mr-8"
              >{{ $t("crud.close") }}
            </v-btn>
            <v-btn color="primary" @click="saveItem()"
              >{{ $t("crud.change") }}
            </v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </div>
  </div>
</template>

<script>
import ToolbarAuth from "@/components/navigation/ToolbarAuth";
import Navigation from "@/components/navigation/Navigation";
import FlashMessage from "@/components/input/FlashMessage";
import { getError } from "@/utils/helpers";
import LinkService from "@/services/maintain/LinkService";
export default {
  name: "Users",
  components: {
    FlashMessage,
    ToolbarAuth,
    Navigation,
  },
  data() {
    return {
      error: null,
      dataext: {},
    };
  },
  methods: {
    lowercase() {
      this.dataext.email = this.dataext.email.toLowerCase();
    },
    getData() {
      let Id = 1;
      this.loading = true;
      LinkService.getMain(Id)
        .then((response) => {
          this.dataext = response.data.data;
        })
        .finally(() => (this.loading = false));
    },
    saveItem() {
      let Id = 1;
      const payload = {
        chart_full: this.dataext.chart_full,
        chart_full_en: this.dataext.chart_full_en,
        chart_light: this.dataext.chart_light,
        pqs_a: this.dataext.pqs_a,
        pqs_b: this.dataext.pqs_b,
        pqs_c: this.dataext.pqs_c,
        pqs_d: this.dataext.pqs_d,
        pqs_e: this.dataext.pqs_e,
        pqs_f: this.dataext.pqs_f,
        pqs_g: this.dataext.pqs_g,
        pqs_h: this.dataext.pqs_h,
        pqs_i: this.dataext.pqs_i,
        pqs_j: this.dataext.pqs_j,
        plp_a: this.dataext.plp_a,
        plp_b: this.dataext.plp_b,
        plp_c: this.dataext.plp_c,
        plp_d: this.dataext.plp_d,
        plp_e: this.dataext.plp_e,
        plp_f: this.dataext.plp_f,
        plp_g: this.dataext.plp_g,
        plp_h: this.dataext.plp_h,
        plp_i: this.dataext.plp_i,
        plp_j: this.dataext.plp_j,
        
      };
      this.error = null;
      LinkService.updateMain(Id, payload)
        .then(() => {
          this.$router.replace({
            name: "linkIndex",
          });
        })
        .catch((error) => (this.error = getError(error)));
    },

    closeItem() {
      this.$router.replace({
        name: "linkIndex",
      });
    },
  },
  computed: {},
  created() {
    this.getData();
  },
};
</script>

<style scoped></style>
